import React from 'react';
import PropTypes from 'prop-types';
import { Button as Base } from 'rebass';
import styled from 'styled-components';

import { createTransition } from '../theme';

const fontSize = {
  small: 0,
  medium: 1,
  large: 2,
};
const py = {
  small: 1,
  medium: 2,
  large: 3,
};

const ButtonBase = styled(Base).attrs(({ size }) => ({ 'data-size': size }))`
  box-sizing: 'border-box';
  min-width: 96px;
  display: inline-flex;
  align-items: center;
  border-radius: 4px;
  justify-content: center;
  white-space: nowrap;
  outline: none;
  text-decoration: none;
  svg {
    margin-right: 8px;
  }
  cursor: pointer;
  transition: ${({ theme }) =>
    createTransition(['background-color', 'box-shadow', 'border'], {
      duration: theme.duration.normal,
    })};
  &:disabled {
    cursor: default;
  }
  &[data-size='small'] {
    min-height: 28px;
  }
  &[data-size='medium'] {
    min-height: 36px;
  }
  &[data-size='large'] {
    min-height: 44px;
  }
`;

export const Button = React.forwardRef(
  ({ children, variant, size, fullWidth, tabIndex, ...other }, ref) => {
    return (
      <ButtonBase
        {...other}
        width={fullWidth ? '100%' : 'auto'}
        ref={ref}
        variant={variant}
        fontSize={fontSize[size]}
        fontWeight="500"
        px={16}
        py={py[size]}
        tabIndex={tabIndex}
        size={size}
      >
        {children}
      </ButtonBase>
    );
  },
);

Button.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.oneOf([
    'primary',
    'default',
    'primaryOutlined',
    'errorOutlined',
    'dangerOutlined',
  ]),
  size: PropTypes.oneOf(Object.keys(fontSize)),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  fullWidth: PropTypes.bool,
  tabIndex: PropTypes.number,
};

Button.defaultProps = {
  type: 'button',
  variant: 'default',
  size: 'medium',
  fullWidth: false,
  tabIndex: 0,
};
